/* menu-section.tsx generated by @compiled/babel-plugin v0.29.1 */
import "./menu-section.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { createContext, useContext } from 'react';
import { useUID } from 'react-uid';
import invariant from 'tiny-invariant';
var MenuSectionContext = /*#__PURE__*/createContext(null);
var useMenuSectionContext = function useMenuSectionContext() {
  var context = useContext(MenuSectionContext);
  invariant(context, 'useMenuSectionContext must be used within a MenuSection');
  return context;
};

/**
 * __MenuSection__
 *
 * A composable component for grouping menu items, along with a heading (`MenuSectionHeading`) and a divider (`Divider`).
 *
 * Usage example:
 * ```jsx
 * <MenuSection>
 *   <MenuSectionHeading>Section heading</MenuSectionHeading>
 *   <MenuList>
 *     <MenuItem>Item 1</MenuItem>
 *     <MenuItem>Item 2</MenuItem>
 *   </MenuList>
 *   <Divider />
 * </MenuSection>
 * ```
 */
export var MenuSection = function MenuSection(_ref) {
  var children = _ref.children;
  var id = useUID();
  return /*#__PURE__*/React.createElement(MenuSectionContext.Provider, {
    value: id
  }, /*#__PURE__*/React.createElement("div", {
    role: "group",
    "aria-labelledby": "".concat(id, "-heading")
  }, children));
};
var headingStyles = null;
export var MenuSectionHeading = function MenuSectionHeading(_ref2) {
  var children = _ref2.children;
  var id = useMenuSectionContext();
  return /*#__PURE__*/React.createElement("h2", {
    id: "".concat(id, "-heading"),
    className: ax(["_syaz131l _11c816g6 _1rjcu2gc _bozg12x7"])
  }, children);
};